import { connect } from 'react-redux';
import { closeModal } from '../modal/modalActions';
import RegisterConfirmation from './RegisterConfirmation';

const mapStateToProps = state => ({
  redirect: state.modal &&
    state.modal.event &&
    state.modal.event.detail ?
    state.modal.event.detail.redirectAfterCreate :
    undefined,
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterConfirmation);
